import { API } from "@/main";

const state = {
  exportTypes: null
};

const getters = {
  getExportTypes: state => state.exportTypes
};

const mutations = {
  SET_EXPORT_TYPES(state, exportTypes) {
    state.exportTypes = exportTypes;
  }
};

const actions = {
  GET_ALL_EXPORTS: ({ commit }) => {
    return new Promise((resolve, reject) => {
      API.export.getAll(
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_EXPORTS_BY_TYPE: ({ commit }, type) => {
    return new Promise((resolve, reject) => {
      API.export.getByType(
        type,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchExportMapperTemplates: ({ commit }) => {
    return new Promise((resolve, reject) => {
      API.export.getExportMapperTemplates(
        result => {
          let exportTypes = result.data.data;
          commit("SET_EXPORT_TYPES", exportTypes);
          resolve(exportTypes);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_EXPORT_MAPPER_TEMPLATES_BY_PAGE: ({ commit }, page) => {
    return new Promise((resolve, reject) => {
      API.export.getExportMapperTemplatesByPage(
        page,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_EXPORTS_BY_LEVEL: ({ commit }, level) => {
    return new Promise((resolve, reject) => {
      API.export.getByLevel(
        level,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_EXPORTS_BY_TYPE_AND_WORKSPACE: ({ commit }, { type, workspaceID }) => {
    return new Promise((resolve, reject) => {
      API.export.getByTypeAndWorkspace(
        type,
        workspaceID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchExportByUUID: ({ commit }, uuid) => {
    return new Promise((resolve, reject) => {
      API.export.getByUUID(
        uuid,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  getCustomReportListOptions: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.export.getCustomReportListOptions(
        data,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  getObjectsToSelectInExport: ({ commit }, workspaceUUID) => {
    return new Promise((resolve, reject) => {
      API.export.getObjectsToSelectInExport(
        workspaceUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  CREATE_EXPORT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.export.create(
        data,
        result => {
          resolve(result.data.export);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  downloadSplicePlan: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.export.create(
        data,
        result => {
          resolve(result.data.export);
        },
        error => {
          reject(error);
        },
        true,
      );
    });
  },

  removeExportByUUID({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.export.deleteByUUID(
        uuid,
        result => {
          resolve(result.data.export);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  cancelExportByUUID({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.export.cancelByUUID(
        uuid,
        result => {
          resolve(result.data.export);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  removeExportsInBulk({ commit }, exportsToRemove) {
    return new Promise((resolve, reject) => {
      API.export.deleteInBulk(
        exportsToRemove,
        result => {
          resolve(result.data.export);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/export.js